const sendFrameworkMessage = window.IntouchGames.GameFramework.ModuleMessenger.sendMessage;

export class FrameworkMessenger
{
    public static readonly debug: boolean = false;

    public static sendMessage(message: any)
    {
        if (FrameworkMessenger.debug)
            console.log("Igb wrapper send " + message.constructor.name + " message.");

        sendFrameworkMessage(message);
    }
}
